// FROM & TOOO CODE

import React, { useCallback, useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import i18next, { t } from "i18next";
import {
  Input,
  DatePicker,
  Select,
  Breadcrumb,
  AutoComplete,
  Image,
} from "antd";
import {
  CloseOutlined,
  DoubleRightOutlined,
  LoadingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../Routes";
import plus from "../../assets/Images/plus.svg";
// import AddVendor from "./AddVendor";
import {
  createPurchaseOrder,
  getPayTerms,
  getPurchaseProducts,
  getVendors,
  updatePOImages,
} from "../../API  Functions/PurchaseFunctions";
import { useDispatch, useSelector } from "react-redux";
import ExpiryModal from "../../modals/ExpiryModal";
// import ProductTable from "./ProductTable";
import PurchasePayment from "../../modals/purchasePaymentModal";
import SuccessModal from "../../modals/Sucessmodal";
import BarcodeScanner from "react-barcode-reader";
import {
  InventorySearchonboard,
  InventorySearchonboardBarcode,
} from "../../API  Functions/InventoryFunctions";
import axiosInstance from "../../AxiosInstance";
import { toast } from "react-toastify";
import LoadingSpinner from "../../components/Loading";
// import UploadBillImage from "./uploadBillImage";
import { UserImageUpload } from "../../API  Functions/UserMangement";
import AddBarcode from "../../modals/AddBarcodeModal";
import dayjs from "dayjs";
import { getSubstores } from "../../API  Functions/ProfileFunctions";
import {
  createStockTransfer,
  searchSubstoreInventory,
} from "../../API  Functions/subStoreFunctions";
import StockTransferProductTable from "./Tables/stockTransferProcutTable";

const StockTransfer = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [vendor, setVendor] = useState(null);
  const [billDate, setBillDate] = useState(null);
  const [billNumber, setBillNumber] = useState("");
  const [vat, setVat] = useState(0);
  const [vatNum, setVatNum] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productList, setProductList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [billDiscount, setBillDiscount] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [showComponent, setShowComponent] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [value, setValue] = useState("");
  const [Productoptions, setProductoptions] = useState([]);
  const [billDiscountPer, setBillDiscountPer] = useState(0);
  const [billDiscountVal, setBillDiscountVal] = useState(0);
  const [totalVatVal, settotalVatVal] = useState(0);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
  const [isDraft, setIsDraft] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPayModalVisible, setIsPayModalVisible] = useState(false);
  const [orderId, setOrderId] = useState(0);
  const [requestProduct, setrequestProduct] = useState(false);
  const [loading, setLoading] = useState(false);
  const [base64Images, setBase64Images] = useState([]);
  const [addImage, setAddImage] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const [currentProductIndex, setCurrentProductIndex] = useState(null);
  const [savedExpiryData, setSavedExpiryData] = useState({});
  const [isOrderCreated, setIsOrderCreated] = useState(false); // New state to track if the order is created
  const [popup, setpopup] = useState(false);
  const [isBarcodeModalVisible, setIsBarcodeModalVisible] = useState(false);
  const [isAddBarcodeModalOpen, setIsAddBarcodeModalOpen] = useState(false);

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  const location = useLocation();
  const { orderData } = location.state || {};

  const vendorData = useSelector((state) => state.form.vendor);
  const billDateData = useSelector((state) => state.form.billDate);
  const billNumberData = useSelector((state) => state.form.billNumber);
  const vatNumData = useSelector((state) => state.form.vatNum);
  const productListData = useSelector((state) => state.form.productList);
  const [isFileValid, setFileValid] = useState(true);

  const [subStores, setSubStores] = useState([]);
  const [selectedSubStore, setSelectedSubStore] = useState(null);
  const masterStore = useSelector((state) => state.login.masterStore);
  // const [fromStore, setFromStore] = useState(masterStore?.store_id || null);
  const [fromStore, setFromStore] = useState(masterStore || null);
  const [searching, setSearching] = useState(false);

  console.log("fromStore", fromStore);
  console.log("selectedSubStore", selectedSubStore);

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const isSaveDisabled = !selectedSubStore || productList.length === 0;

  useEffect(() => {
    if (masterStore) {
      getSubStoresData();
    }
  }, [masterStore]);

  const getSubStoresData = () => {
    getSubstores(masterStore?.store_id).then((res) => {
      console.log("Substores Res", res);

      setSubStores(res?.response);
    });
  };

  const handleProductChange = (index, key, value) => {
    const updatedProductList = [...productList];

    if (key === "purchaseQty") {
      value = parseFloat(value) || 0;
    }

    updatedProductList[index][key] = value;

    setProductList(updatedProductList);

    const purchaseQty = updatedProductList[index]?.purchaseQty || 0;

    const prodSalePrice = updatedProductList[index]?.salesPrice;

    setProductList(updatedProductList);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (value.length >= 3) {
        getPurchaseProducts(user_id, value, 10, 0)
          .then((res) => {
            console.log("EEEEEEEEE", res);

            if (res?.result && res.result.length > 0) {
              const products = res.result;
              setProductoptions(products);
            } else if (
              res?.result?.status_code === 400 &&
              res?.result?.status === "Does Not Found any Product"
            ) {
              toast.error(t("Product not found"));
            } else {
              setProductoptions([]);
            }
          })
          .catch(() => {
            setProductoptions([]);
          });
      } else {
        setProductoptions([]);
      }
    }, 1000),
    [] // make sure this is not recreated on every render
  );

  const handleProductSelect = (value) => {
    const selectedProduct = Productoptions.find(
      (product) => product.name === value
    );

    if (selectedProduct) {
      // Check if the product has a barcode
      if (!selectedProduct.barcode) {
        // If no barcode, open the modal to input the barcode
        setSelectedProduct(selectedProduct);
        setSelectedProductId(selectedProduct.prod_id);
        setIsBarcodeModalVisible(true);
        return; // Exit the function to prevent adding the product
      }
    }

    if (selectedProduct) {
      // Check if the product is already in the productList
      const isDuplicate = productList.some(
        (product) => product.prod_id === selectedProduct.prod_id // Assuming prod_id is unique
      );

      if (isDuplicate) {
        // Optionally, show a message to the user
        toast.error(`${selectedProduct.name} is already in the list.`); // Replace with a more user-friendly message or modal if needed
        return;
      }

      const productWithQty = {
        ...selectedProduct,
        purchaseQty: 0,
        salesPrice: selectedProduct?.sale_price,
      };
      setSelectedProduct(productWithQty);
      setProductList([...productList, productWithQty]);
      setSearchValue("");
      setValue("");
      setProductoptions([]);
    }
  };

  const handleDeleteProduct = (index) => {
    const updatedProductList = [...productList];
    updatedProductList.splice(index, 1);
    setProductList(updatedProductList);
  };

  const handleCancel = () => {
    setProductList([]);
    setProductoptions([]);
    setIsDraft(false);
    setCurrentProductIndex("");
  };

  // console.log("PROD", productList);

  const handleSavePurchaseOrder = async () => {
    // Validate product list
    // console.log("Saving product list:", productList);

    for (const product of productList) {
      if (product.purchaseQty <= 0) {
        toast.error(t("Transfer Quantity cannot be 0."));
        return;
      }
      if (product.purchaseQty > product.parent_store_stock) {
        toast.error(
          t("Transfer Quantity cannot be more than Current Inventory") +
          ` (${i18next.language === "ar"
            ? fromStore?.store_name_ar
            : fromStore?.store_name
          })`
        );
        // toast.error(t("Transfer Quantity cannot be more than Current Inventory (Master Store)."));
        return;
      }
    }

    // Build payload for the new API
    const payload = {
      parent_store_id: fromStore?.store_id,
      child_store_id: selectedSubStore?.store_id,
      status: "Done",
      lines: productList.map((product) => ({
        product_id: product.prod_id,
        parent_company_stock: product.parent_store_stock ?? 0, // Add field mapping
        child_company_stock: product.child_store_stock ?? 0,
        transfer_quantity: product.purchaseQty ?? 0,
      })),
    };

    // console.log("Payload for stock transfer:", payload);

    setLoading(true);
    try {
      const response = await createStockTransfer(payload); // <-- Call the new API
      // console.log("Stock transfer response:", response);

      if (response?.result?.status_code === 200) {
        toast.success(t(response.result.status));
        setOrderId(response.result.transfer_id); // Save transfer_id
        setProductList([]);
        setProductoptions([]);
        setIsDraft(false);
      } else {
        toast.error(
          t(response?.result?.status || "Failed to create stock transfer")
        );
      }
    } catch (error) {
      console.error("Failed to create stock transfer:", error);
      toast.error(t("Something went wrong while creating stock transfer."));
    } finally {
      setLoading(false);
    }
  };

  const handleclose = () => {
    setProductList([]);
    setIsOrderCreated(false);
    setLoading(false);
  };

  const searchProduct = async (value) => {
    let res = await InventorySearchonboardBarcode(value);
    // console.log("API Response Barcode:", res);

    if (res.result && Array.isArray(res.result)) {
      const productResponse = res.result[0];
      // console.log("PPPPPp", productResponse);

      if (productResponse.status_code === 400) {
        // If product not found, try fetching from GS1 API
        try {
          const fetchGtinResponse = await axiosInstance.post(
            "/fetch_gs1_data",
            {
              gtin: value, // Use the barcode value
            }
          );

          if (fetchGtinResponse.data && fetchGtinResponse.data.result) {
            const fetchedProduct = fetchGtinResponse.data.result;

            // Check if the fetched product has the necessary data
            if (fetchedProduct.gtin) {
              // Redirect to ProductRequest page with fetched product data
              navigate("/inventory/ProductRequest", {
                state: {
                  fetchedProduct,
                  // product_description_english: fetchedProduct.product_description_english,
                  // product_description_arabic: fetchedProduct.product_description_arabic,
                  // barcode: fetchedProduct.gtin,
                },
              });
            } else {
              // Show the Request Product option if no product found
              setrequestProduct(true);
              setProductoptions([]);
              setValue("");
              // setIsProductFound(false);
            }
          } else {
            // Handle case where no result is returned
            setrequestProduct(true);
            setProductoptions([]);
            setValue("");
            // setIsProductFound(false);
          }
        } catch (error) {
          console.error("Error fetching GS1 data:", error);
          setrequestProduct(true); // Show Request Product option on error
        }
      } else {
        // Fill out the input fields with the found product data
        // console.log("PPP", productResponse);

        const isDuplicate = productList.some(
          (product) => product.prod_id === productResponse.prod_id // Assuming prod_id is unique
        );

        if (isDuplicate) {
          // Optionally, show a message to the user
          setSearchValue("");
          setValue("");
          toast.error(`${productResponse.name} is already in the list.`); // Replace with a more user-friendly message or modal if needed
          return; // Exit the function to prevent adding the duplicate
        }

        const productWithQty = {
          ...productResponse,
          vat: 0,
          purchaseQty: 0,
          freeQty: 0,
          discount: 0,
          discountValue: 0,
          salesPrice: productResponse?.sale_price,
          totalValue: 0,
          includingVat: 0,
          effectivePrice: 0,
          profit: 0,
        };
        setSelectedProduct(productWithQty);
        setProductList([...productList, productWithQty]);
        setSearchValue("");
        setValue("");

        if (productResponse?.cost_price > 0) {
          // formik.setFieldValue("cost_price", productResponse.cost_price);
        }

        if (productResponse?.sale_price > 0) {
          // formik.setFieldValue("sale_price", productResponse.sale_price);
        }
      }
    }
  };

  const searchBarcodeResult = useCallback(
    debounce((value) => {
      searchProduct(value);
    }, 1000),
    []
  );

  const searchResult = useCallback(
    debounce(async (value) => {
      setSearching(true); // start loader
      try {
        let parent_store_id = fromStore?.store_id;
        let res = await searchSubstoreInventory(
          value,
          parent_store_id,
          selectedSubStore?.store_id
        );

        console.log("API Response:", res?.result);

        if (
          res.result?.status_code === 400 &&
          res.result?.status === "Does Not Found any Product"
        ) {
          toast.error(t("Product not found"));
        }

        if (res.result?.response && Array.isArray(res.result?.response)) {
          const productResponse = res.result?.response[0];
          if (productResponse.status_code === 400) {
            setProductoptions([]);
          } else {
            setProductoptions(res.result?.response || []);
            setrequestProduct(false);
          }
        } else {
          setProductoptions([]);
          setrequestProduct(false);
        }
      } catch (err) {
        console.error(err);
        setProductoptions([]);
      } finally {
        setSearching(false); // stop loader always
      }
    }, 1000),
    [selectedSubStore, masterStore]
  );

  return (
    <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
      <div className="mx-3 flex flex-col justify-center bg-[#F6F7F9]">
        {loading && <LoadingSpinner />}
        <Navbar heading={t("Stock Transfer")} />
        <div className="overflow-y-auto custom-scrollbar">

          <div className="my-5">
            {/* From + To Stores Row */}
            <div className="flex gap-6 w-1/2 mt-5">
              {/* FROM Store */}
              <div className="w-1/2">
                <label className="block font-medium">{t("From")}</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select From Store")}
                  className="h-10 mt-2"
                  value={fromStore?.store_id || null}
                  disabled={productList.length > 0}
                  onChange={(value) => {
                    const selected =
                      value === masterStore?.store_id
                        ? masterStore
                        : subStores.find((store) => store.store_id === value);
                    setFromStore(selected);
                  }}
                  showSearch
                >
                  {/* Master Store option */}
                  {(!selectedSubStore ||
                    masterStore?.store_id !== selectedSubStore?.store_id) && (
                      <Select.Option
                        key={masterStore?.store_id}
                        value={masterStore?.store_id}
                      >
                        {i18next.language === "ar"
                          ? masterStore?.store_name_ar
                          : masterStore?.store_name}
                      </Select.Option>
                    )}

                  {/* Sub Stores */}
                  {subStores
                    .filter(
                      (store) => store.store_id !== selectedSubStore?.store_id
                    )
                    .map((store) => (
                      <Select.Option key={store.store_id} value={store.store_id}>
                        {i18next.language === "ar"
                          ? store.store_name_ar
                          : store.store_name}
                      </Select.Option>
                    ))}
                </Select>
              </div>

              {/* TO Store */}
              <div className="w-1/2">
                <label className="block font-medium">{t("To")}</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select To Store")}
                  className="h-10 mt-2"
                  disabled={productList.length > 0}
                  value={selectedSubStore?.store_id}
                  onChange={(value) => {
                    const selected = subStores.find(
                      (store) => store.store_id === value
                    );
                    setSelectedSubStore(selected);
                  }}
                  showSearch
                >
                  {subStores
                    .filter((store) => store.store_id !== fromStore?.store_id)
                    .map((store) => (
                      <Select.Option key={store.store_id} value={store.store_id}>
                        {i18next.language === "ar"
                          ? store.store_name_ar
                          : store.store_name}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            </div>

            {/* Product Search Row */}
            <div className="flex justify-between mt-8 w-1/2">
              {selectedSubStore && (
                <span className="relative w-full">
                  <AutoComplete
                    value={value}
                    options={Productoptions.map((option) => ({
                      value: option.name,
                      label: option.name,
                    }))}
                    onSearch={(val) => {
                      setValue(val);
                      if (val.length >= 3) {
                        searchResult(val);
                      } else {
                        setrequestProduct(false);
                        setProductoptions([]);
                      }
                    }}
                    onSelect={handleProductSelect}
                    style={{ width: "100%", height: "43px" }}
                  // style={{ width: "100%" }}
                  >
                    <Input
                      placeholder={t("search_product")}
                      size="large"
                      style={{
                        borderColor: "#d9d9d9", // remove border
                        boxShadow: "none", // remove hover/focus glow
                      }}
                      className="custom-input"
                      suffix={
                        searching ? (
                          <LoadingOutlined spin style={{ color: "#1E3ABA" }} />
                        ) : (
                          <SearchOutlined style={{ color: "#1E3ABA" }} />
                        )
                      }
                    />
                  </AutoComplete>
                </span>
              )}

              <BarcodeScanner
                onScan={(data) => {
                  setValue(data);
                  searchBarcodeResult(data);
                }}
                onError={(err) => {
                  console.error(err);
                }}
                facingMode="environment"
                className="absolute inset-y-0 right-0 me-4 pointer-events-none cursor-pointer z-10"
              />
            </div>

            {/* Action Buttons */}
            {productList && productList.length > 0 && (
              <div className="flex flex-row justify-end ms-4 gap-2 mt-5 me-10">
                {!isOrderCreated && (
                  <button
                    onClick={handleCancel}
                    className={`font-semibold w-36 h-10 text-sm border border-primaryBlue rounded-lg bg-white text-primaryBlue flex justify-center items-center gap-2`}
                    type="submit"
                  >
                    <p className="">{t("Cancel")}</p>
                  </button>
                )}
                {!isOrderCreated && (
                  <button
                    onClick={handleSavePurchaseOrder}
                    disabled={isSaveDisabled}
                    className={`font-semibold w-32 h-10 border rounded-lg bg-primaryBlue text-white text-sm flex justify-center items-center gap-2 ${isSaveDisabled ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    type="submit"
                  >
                    <p className="">{t("Save")}</p>
                  </button>
                )}
              </div>
            )}

            {/* Product Table */}
            {productList && productList.length > 0 && (
              <StockTransferProductTable
                disabled={isOrderCreated}
                productList={productList}
                handleProductChange={handleProductChange}
                handleDeleteProduct={handleDeleteProduct}
                fromStoreName={
                  i18next.language === "ar"
                    ? fromStore?.store_name_ar
                    : fromStore?.store_name
                }
                subStoreName={
                  i18next.language === "ar"
                    ? selectedSubStore?.store_name_ar
                    : selectedSubStore?.store_name
                }
              />
            )}
          </div>

          {popup && (
            <SuccessModal
              onClose={() => {
                setpopup(false);
              }}
              message={` ${t("Purchase Order Created Successfully")}  `}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StockTransfer;
